import React, { useState, useEffect, forwardRef } from "react";
import { Tooltip } from "antd";
import { useDispatch } from "react-redux";
import SectionHeader from "../../components/global/SectionHeader";
import { Spin, notification, Select, Button } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";
import { BsArrowLeftSquare } from "react-icons/bs";
import { MdOutlineFormatListBulleted } from "react-icons/md";

const GivenReview = () => {
  const userid = localStorage.getItem("USERID");
  const [array, setArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showmodel, setModel] = useState(false)
  const [description, setDescription] = useState()
  const { id } = useParams()
  console.log(id, 'idd');

  let history = useNavigate()

  useEffect(() => {
    projectAssign();
  }, []);




  const projectAssign = () => {
    setLoading(true);
    let data = {
      projectId: id,
      addedBy: userid
    };
    ApiClient.allApi("project-reviews", data).then((res) => {
      if (res.success) {
        setArray(res.data);
      } else {
        notification.error({
          message: res.message,
        });
      }
      setLoading(false);
    });
  };

  const showView = (e) => {
    setModel(true)
    setDescription(e)
  }






  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.projectId?.name ? (
       
              <Tooltip >

                <span className="text-capitalize">{text && text.projectId?.name}</span>
              </Tooltip>
          
          ) : (
            "--"
          )}
        </>
      ),
    },
    {
      title: "Reviewed to",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.employeeId?.fullName ? (
            <Tooltip title="View">
              <span className="text-capitalize">{text && text.employeeId?.fullName} ({text?.employeeId?.department})</span>
            </Tooltip>

          ) : (
            "--"
          )}
        </>
      ),
    },
    {
      title: "Description",
      dataIndex: "dectiption",
      field: "decription",
      render: (text, record) => (
        <>
          {text && text?.description ? (
            // <a onClick={() => showView(text.description)}

            //   dangerouslySetInnerHTML={{ __html: text.description }}
            // />
            <Link to={`/ViewReview/${text.id}`} className="text">
            {/* <a onClick={() => showView(text.description)}> */}
              <Tooltip title="View">
                <span><MdOutlineFormatListBulleted style={{ fontSize: "18px" }} />
                </span>
              </Tooltip>
            {/* </a> */}
</Link>
            // <Tooltip title="View">
            //   <span>{text && text.description}</span>
            // </Tooltip>

          ) : (
            "--"
          )}
        </>
      ),
    },




  ];


  const setReviewModalModal = (e) => {
    setModel(false);
    setDescription({ description: '' })


  };


  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
        return {
          ...items,
        };
      })
      : [];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  return (
    <Layout>
      <div>
        <div className="main-content">
          <div className="section table table-striped">
            <div className="headings">
              <div className="d-flex align-items-center">
                <Tooltip title="Back Button">
                  <p
                    onClick={() => history(-1)}
                    className="pointer text-white  fs-3"
                  >
                    <BsArrowLeftSquare />
                  </p>
                </Tooltip>
                <SectionHeader title="Reviews" />
              </div>
            </div>
            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={columns}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>
        </div>
      </div>

      {showmodel ? (
        <div class="modal d-block scroll_fade">
          <div class="modal-dialog">
            <div class="modal-content border-0 p-3 rounded-0 bg_congoratulations">
              <div class="mb-2 textend_modal">
                <div className="d-flex justify-content-between align-items-center">
                  <h5>Give Review</h5>

                  <button
                    type="button"
                    class="btn-close ms-auto"
                    onClick={() => setReviewModalModal(false)}
                  >
                  </button>
                </div>
                <div
                  // class="tab-pane fade "
                  id="api"
                  role="tabpanel"
                  aria-labelledby="api-tab"
                >
                  <div className="mt-2">
                    <div className="text-center"
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </Layout>
  );
};

export default GivenReview;
